module.exports = __webpack_public_path__ + "static/ftrs-logo-white-41d0bff3d5dfb59835884faf337f01de.svg";